




















































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { IFormOption, INPUT_TYPES } from '@/components/form/FieldTypes'

@Component
export default class FieldCondition extends Vue {
  @Prop(Object) public option!: IFormOption
  @Prop(Object) public value!: IFormOption
  @Prop({default: () => ({})}) public form!: any

  public isTiltle(): boolean {
    return this.option.type === INPUT_TYPES.TITLE
  }

  public isDescription(): boolean {
    return this.option.type === INPUT_TYPES.DESCRIPTION
  }

   public isSubTiltle(): boolean {
    return this.option.type === INPUT_TYPES.SUBTITLE
  }

  public isTextField(): boolean {
    return this.option.type === INPUT_TYPES.TEXT
  }

  public isTextarea(): boolean {
    return this.option.type === INPUT_TYPES.TEXTAREA
  }

  public isSelect(): boolean {
    return this.option.type === INPUT_TYPES.SELECT
  }

  public isAutoComplete(): boolean {
    return this.option.type === INPUT_TYPES.AUTOCOMPLETE
  }

  public isCheckbox(): boolean {
    return this.option.type === INPUT_TYPES.CHECKBOOK
  }

  public isRadio(): boolean {
    return this.option.type === INPUT_TYPES.RADIO
  }

  public isSwitchToggle(): boolean {
    return this.option.type === INPUT_TYPES.SWITCHTOGGLE
  }

  public isDate(): boolean {
    return this.option.type === INPUT_TYPES.DATE
  }

  public isTime(): boolean {
    return this.option.type === INPUT_TYPES.TIME
  }

  public isGroup(): boolean {
    return this.option.type === INPUT_TYPES.GROUP
  }
}
